import React from "react";

// Custom dropdown for risk level
const RiskLevelDropdown = ({ value, onChange }) => (
  <div className="mt-3 border-t border-gray-200 pt-2">
    <div className="text-xs text-gray-600 mb-2">
      If enabled, transactions with a risk score above your selected threshold will be blocked.
      Set your acceptable maximum risk score (0 = most strict, 100 = most lenient).
    </div>
    <label className="block text-xs text-gray-700 mb-1 font-semibold">
      Risk Score Threshold:
    </label>
    <div className="flex items-center gap-2">
      <input
        type="number"
        min={0}
        max={100}
        step={1}
        value={typeof value === "number" ? value : ""}
        onChange={(e) => {
          const val = Math.max(0, Math.min(100, Number(e.target.value)));
          onChange(val);
        }}
        className="w-20 px-2 py-1 border rounded focus:ring focus:ring-blue-200 text-sm"
      />
      <span className="text-xs text-gray-500">
        (Default: 70, Lower blocks more)
      </span>
    </div>
  </div>
);

export const DETECTION_RULES = [
  {
    group: "⚙️ Standard Detection Rule",
    items: [
      {
        name: "Block disposable or low-reputation emails",
        desc: "",
      },
      {
        name: "Early Fraud Warning Detection",
        desc: "",
      },
      {
        name: "Too high risk level",
        desc: "Block payments with a Stripe risk score above your selected threshold.",
        dropdown: RiskLevelDropdown,
        dropdownKey: "risk_level_threshold", // what prop in state to bind
      },
      {
        name: "Country blocked",
        desc: "",
      },
    ],
  },
  {
    group: "Under development",
    items: [
      {
        name: "One trial per device/IP/email",
        desc: "",
      },
      {
        name: "Detect promo/referral abuse",
        desc: "",
        dropdown: () => (
          <div className="mt-3 border-t border-gray-200 pt-2 text-xs text-gray-600">
            (Example: Here could be inputs for custom abuse thresholds, time windows, etc.)
          </div>
        ),
      },
      {
        name: "Scraping & throttling detection",
        desc: "",
      },
      {
        name: "Account farming & refund flagging",
        desc: "",
      },
      {
        name: "Signup Velocity Analysis",
        desc: "Rate-limit by IP /24 block or subnet to stop mass signups.",
      },
      {
        name: "Promo Code Use Velocity",
        desc: "Alert on unusual bursts of redemptions.",
      },
      {
        name: "Behavioral Entropy Score",
        desc: "Mouse movements, keypresses, delay variance—flag robotic behavior.",
      },
      {
        name: "Timezone Mismatch Detection",
        desc: "Compare browser-reported timezone with IP geolocation.",
      },
      {
        name: "Referrer & Origin Mismatch",
        desc: "Block traffic with faked headers or iframe embedding attempts.",
      },
      {
        name: "Credit Card Reuse Fingerprint",
        desc: "Detect same payment info reused across multiple accounts.",
      },
      {
        name: "Device Fingerprint Reuse",
        desc: "Track browser fingerprint hashes linked to many accounts.",
      },
    ],
  },
];


//{ name: "Credit Card BIN Analysis", desc: "" },
//{ name: "IP Geolocation & Proxy Detection", desc: "" },